import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 气泡模式 220
 */

export default class EventBubbleMode extends EventBase {
  constructor() {
    super()
    this.Parameter = [
      '1',
      '1',
      '0',
      '0',
      '0',
      '270',
      '480',
      '0',
      '0',
      '0',
      '0',
      '0',
      '0',
      '100',
      '100',
      '255',
      '0',
      '',
      '',
    ]
  }

  /**
   * 编号（3-22）
   */
  get ID() {
    return parseInt((this.Parameter && this.Parameter[0]) ?? '-1')
  }
  set ID(val) {
    this.Parameter![0] = val.toString()
  }

  /**
   * 开关（0：关，1：开）
   */
  get Switch() {
    return parseInt((this.Parameter && this.Parameter[1]) ?? '')
  }
  set Switch(val) {
    this.Parameter![1] = val.toString()
  }
  /**
   * 保留/清除（0：清除1：保留）
   */
  get Clear() {
    return parseInt((this.Parameter && this.Parameter[2]) ?? '')
  }
  set Clear(value) {
    this.Parameter![2] = value.toString()
  }

  /**
   * 起始X坐标
   */
  get X() {
    return parseInt((this.Parameter && this.Parameter[3]) ?? '-1')
  }
  set X(value) {
    this.Parameter![3] = value.toString()
  }

  /**
   * 起始Y坐标
   */
  get Y() {
    return parseInt(this.Parameter?.[4] ?? '-1')
  }
  set Y(value) {
    this.Parameter![4] = value.toString()
  }

  /**
   * 区域宽度
   */
  get AreaWidth() {
    return parseInt((this.Parameter && this.Parameter[5]) ?? '')
  }
  set AreaWidth(value) {
    this.Parameter![5] = value.toString()
  }

  /**
   * 区域高度
   */
  get AreaHeight() {
    return parseInt((this.Parameter && this.Parameter[6]) ?? '')
  }
  set AreaHeight(value) {
    this.Parameter![6] = value.toString()
  }

  /**
   * 显示信息
   */
  get Description() {
    if (this.Parameter && this.Parameter[7] && this.Parameter[7].length > 0) {
      return this.Parameter[7]
    }
    return ''
  }
  set Description(value) {
    this.Parameter![7] = value.toString()
  }

  /**
   * 区域上边距
   */
  get AreaTop() {
    if (this.Parameter && this.Parameter[8] && this.Parameter[8].length > 0) {
      return parseInt((this.Parameter && this.Parameter[8]) ?? '')
    }
    return 0
  }
  set AreaTop(value) {
    this.Parameter![8] = value.toString()
  }

  /**
   * 区域下边距
   */
  get AreaBottom() {
    if (this.Parameter && this.Parameter[9] && this.Parameter[9].length > 0) {
      return parseInt((this.Parameter && this.Parameter[9]) ?? '')
    }
    return 0
  }
  set AreaBottom(value) {
    this.Parameter![9] = value.toString()
  }

  /**
   * 区域左边距
   */
  get AreaLeft() {
    if (this.Parameter && this.Parameter[10] && this.Parameter[10].length > 0) {
      return parseInt((this.Parameter && this.Parameter[10]) ?? '')
    }
    return 0
  }
  set AreaLeft(value) {
    this.Parameter![10] = value.toString()
  }

  /**
   * 区域右边距
   */
  get AreaRight() {
    if (this.Parameter && this.Parameter[11] && this.Parameter[11].length > 0) {
      return parseInt((this.Parameter && this.Parameter[11]) ?? '')
    }
    return 0
  }
  set AreaRight(value) {
    this.Parameter![11] = value.toString()
  }

  /**
   * 区域ID
   */
  get RegionId() {
    if (this.Parameter && this.Parameter[12] && this.Parameter[12].length > 0) {
      return parseInt((this.Parameter && this.Parameter[12]) ?? '')
    }
    return 0
  }
  set RegionId(value) {
    this.Parameter![12] = value.toString()
  }

  /**
   * X轴缩放率
   */
  get ZoomX() {
    return parseInt((this.Parameter && this.Parameter[13]) ?? '')
  }
  set ZoomX(value) {
    this.Parameter![13] = value.toString()
  }

  /**
   * Y轴缩放率
   */
  get ZoomY() {
    return parseInt((this.Parameter && this.Parameter[14]) ?? '')
  }
  set ZoomY(value) {
    this.Parameter![14] = value.toString()
  }

  /**
   * 图片透明度，0~255
   */
  get Opacity() {
    return parseInt((this.Parameter && this.Parameter[15]) ?? '')
  }
  set Opacity(value) {
    this.Parameter![15] = value.toString()
  }

  /**
   * 是否使用了镜像功能
   * 0否1是
   */
  get IsMirror() {
    return this.Parameter?.[16] == '1'
  }
  set IsMirror(value) {
    this.Parameter![16] = value ? '1' : '0'
  }

  /**
   * 17,18拓展
   */
  Code = EventID.AirBubbleMode

  public GetParameter() {
    return this.Parameter
  }
}
